/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useSearchTriggerInput } from '../search-trigger-context';
var inputStyles = null;
export var SearchTriggerInputElement = function SearchTriggerInputElement(_ref) {
  var id = _ref.id;
  var _useSearchTriggerInpu = useSearchTriggerInput(),
    value = _useSearchTriggerInpu.value,
    _onChange = _useSearchTriggerInpu.onChange,
    setIsFocused = _useSearchTriggerInpu.setIsFocused,
    setIsHovered = _useSearchTriggerInpu.setIsHovered;
  return /*#__PURE__*/React.createElement("input", {
    "data-testid": "csm-ai-search-input",
    id: id,
    value: value,
    name: "message",
    onChange: function onChange(e) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(e.currentTarget.value);
    },
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    autoComplete: "off",
    spellCheck: "false",
    className: ax(["_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _11c81ixg _r06hglyw _bfhk1j28 _4t3i1osq _1bsb1osq _syaz1fxt _vchhusvi _1q51idpf _85i5idpf _bozgoahv _y4tiu2gc"])
  });
};